'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getCurrentProtocol() {
    return location.protocol.indexOf('http') === -1 ? 'https:' : location.protocol;
}

exports.getCurrentProtocol = getCurrentProtocol;
